<template>
  <div class="container-list flex">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other" style="padding-right: 5px"></i>
        巡查记录详情
      </div>
    </div>
    <div class="flex1 record-content">
      <div class="header">
        <div class="item" v-for="(item, key) in headerOptions">
          <span class="width120">{{ item }}</span
          >{{ key }}
        </div>
      </div>
      <el-table :data="tableData" :span-method="objectSpanMethod" border style="width: 100%; margin-top: 20px">
        <el-table-column prop="comprehensiveName" label="" width="120" align="center"> </el-table-column>
        <el-table-column prop="PatrolContents" label="巡查内容"> </el-table-column>
        <el-table-column prop="amount1" label="结果"> </el-table-column>
        <el-table-column prop="amount2" label="位置"> </el-table-column>
        <el-table-column prop="amount3" label="巡查数据"> </el-table-column>
        <el-table-column prop="amount3" width="300px" label="照片">
          <template>
            <div>
              <div><strong>图片编号：</strong></div>
              <div>拍摄时间：</div>
              <div>拍摄内容：</div>
              <div>文字描述：</div>
              <div>备注：</div>
              <div>
                <img
                  src="https://d1icd6shlvmxi6.cloudfront.net/gsc/ZZ770V/ac/4b/79/ac4b794598de482b8700bb6da56ad9ee/images/%E5%B7%A1%E6%9F%A5%E8%A1%A8_%E6%97%A5%E5%B8%B8_/u1407.png"
                  alt=""
                />
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="btn-box  center" style="margin-bottom: 40px">
      <el-button type="primary" @click="$router.back()">下载文档</el-button>
      <el-button type="primary" @click="$router.back()">返回</el-button>
    </div>
  </div>
</template>

<script>
// import {buildList} from './options'
// import {addCompany, editCompany} from "../../api/company";
// import {getArea} from "../../api/common";
import { getSafeList } from "../../api/safety";

export default {
  data() {
    return {
      headerOptions: {
        a: "文物建筑名称",
        b: "路名门牌",
        c: "巡查日期",
        d: "巡查范围",
        e: "巡查人",
        f: "巡查方法",
        g: "极端天气记录",
      },
      tableData: [
        {
          comprehensiveName: "生物病害",
          PatrolContents: "生物病害",
          amount1: "234",
          amount2: "3.2",
          amount3: 10,
        },
        {
          comprehensiveName: "生物病害",
          PatrolContents: "动物病害",
          amount1: "234",
          amount2: "3.2",
          amount3: 10,
        },
        {
          comprehensiveName: "生物病害",
          PatrolContents: "病虫害监控",
          amount1: "234",
          amount2: "3.2",
          amount3: 10,
        },
        {
          comprehensiveName: "安全隐患",
          PatrolContents: "消防隐患",
          amount1: "234",
          amount2: "3.2",
          amount3: 10,
        },
        {
          comprehensiveName: "安全隐患",
          PatrolContents: "其他隐患",
          amount1: "234",
          amount2: "3.2",
          amount3: 10,
        },
        {
          comprehensiveName: "其他",
          PatrolContents: "其他",
          amount1: "234111",
          amount2: "3.2222222",
          amount3: 1033333333,
        },
      ],
      id: this.$route.query.id || "",
      form: {},
      rules: {},
      radio: "",
      CheckedKeys: [],
      props: {
        label: "111",
        children: "zo11nes",
      },
      list2: [],
      list: [],
      pos: 0,
      spanArr: [],
    };
  },
  created() {
    if (this.id) {
      this.$post(`/record/recorddetail/${this.id}`).then((res) => {
        this.form = res.data[0];

        if (this.form.c_log_image_url) {
          //整改前
          this.form.imgList = this.form.c_log_image_url.split(",");
        }
        if (this.form.c_log_image_url_out) {
          //整改后
          this.form.imgbackList = this.form.c_log_image_url_out.split(",");
        }
      });
    }
  },
  mounted() {
    this.ergodicData(this.tableData);
  },

  methods: {
    //合并行前数据整理 tableData 就是请求下来的数据
    ergodicData(tableData) {
      for (var i = 0; i < tableData.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          // 判断本次和上一次的 comprehensiveName 值是否相等
          if (tableData[i].comprehensiveName === tableData[i - 1].comprehensiveName) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
        // this.tableData.push({comprehensiveName:'其他'})
      }
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == this.spanArr.length - 1) {
        if (columnIndex === 0) {
          return {
            rowspan: 1,
            colspan: 10,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      } else if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container-list {
  padding: 0 20px;
  height: 100%;
  flex-direction: column;
}
.record-content {
  .header {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 12px;
    .item {
      font-size: 16px;
    }
    .width120 {
      text-align: right;
      padding-right: 12px;
      width: 120px;
      display: inline-block;
    }
  }
}
.tree {
  font-size: 18px;
}
</style>
